import React, { Component } from 'react';
import FormError from '../../models/FormError';
import ErrorFieldMessage from './FieldErrorMessage.Component';

type PostalCodeInputFieldProps = {
    name: string,
    label: string,
    placeholder: string,
    initialValue?: string,
    errors?: FormError[],
    id: string,

    onChange: (name: string, value: string) => Promise<FormError[]>,
}

type PostalCodeInputFieldState = {
    value: string,
    errors: FormError[]
}

export default class PostalCodeInputField extends Component<PostalCodeInputFieldProps, PostalCodeInputFieldState> {
    constructor(props: PostalCodeInputFieldProps) {
        super(props);

        this.state = {
            value: props.initialValue || "",
            errors: props.errors?.filter(err => { return err.field === props.name }) ?? []
        }
    }

    public componentDidUpdate(previousProps: PostalCodeInputFieldProps, previousState: PostalCodeInputFieldState) {
        if (this.props.errors?.length != previousProps.errors?.length) {
            this.setState({
                errors: this.props.errors?.filter(err => { return err.field === this.props.name }) ?? []
            });
        }

        if (!previousProps.initialValue && !!this.props.initialValue && this.props.initialValue != previousProps.initialValue) {
            this.setState({ value: this.props.initialValue || '' })
        }
    }

    public async onSetValue(value: string) {

        const errors = await this.props.onChange(this.props.name, value);

        this.setState({
            value: value,
            errors: errors
        })
    }

    public format(value: string) {
        const numbersRegex: RegExp = /[+]/mg;
        const matches = value.match(numbersRegex);
        let result = '';

        if (value.length > 16) {
            value = value.slice(0, -1);

        }
        this.setState({
            value: value
        })
    }

    public render() {
        return <div className="form-group">
            <label htmlFor={this.props.name}>{this.props.label}</label>

            <input className={"form-control col-4" + (this.state.errors.length > 0 ? " is-invalid" : "")}
                name={this.props.name}
                autoComplete="postal-code"
                onChange={(event: React.ChangeEvent<HTMLInputElement>) => {
                    this.format(event.target.value)
                }}
                onBlur={(event: React.ChangeEvent<HTMLInputElement>) => {
                    this.onSetValue(event.target.value)
                }} placeholder={this.props.placeholder} value={this.state.value} />
            <ErrorFieldMessage name={this.props.name} errors={this.state.errors}></ErrorFieldMessage>
        </div>
    }
}